import axios from "axios";
import React, { useContext, useState, useRef, useEffect } from "react";
//import Select2 from "react-chosen";
import Resizer from "react-image-file-resizer";
import { useNavigate } from "react-router-dom";
import { uploadFile, formatPrice, invoiceCalculate } from "../utils/Common";
import { AppContext } from "../context/context";
import ImageUploader2 from "./ImageUploader2";
import { get, post } from "../services/apiService";
import { useFlashMessage } from "../context/FlashMessageContext";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";

import classNames from "classnames";
import { set } from "react-hook-form";
import SelectImei from "./SelectImei";
import SelectBox from "./Select";
import ItemSelectBox from "./ItemSelectBox";
import { FlashMessage } from "../utils/FlashMessage";

const SalesReturnForm = (props) => {
  let totalAmount = 0;
  const [productListSelect, setProductListSelect] = useState([]);
  const [productSelect, setProductSelect] = useState("");
  const [searchProdFilter, setSearchProdFilter] = useState({
    keyword: "",
  });


  const [totalPaymentAmount, setTotoalPaymentAmount] = useState(0)
  const [paymentForm, setPaymentForm] = useState([{
    methodName: '',
    accountName: "",
    account_number: "",
    payment_type_id: '',
    payment_type_category_id: "",
    Amount: '',
  }]);
  const [showPayment, setShowPayment] = useState(false);
  const [paymentList, setPaymentList] = useState([]);
  const [paymentAccountList, setPaymentAccountList] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [methodIndex, setMethodIndex] = useState(null)
  const [filteredAccountList, setFilteredAccountList] = useState([]);

  const getPayment = () => {
    loadingCallback(true)
    axios.get(
      `${process.env.REACT_APP_API_URL}payment-type-list`,{
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      if(response.data.success){
        loadingCallback(false)
        const cashItem = response?.data?.data?.data?.filter(
          (item) => item?.type_name?.toLowerCase() === 'cash'
        );

        setPaymentData([...paymentData, ...(cashItem || [])]);
        setPaymentList(response?.data?.data?.data);
        setPaymentForm((prev) => {
          const updated = [...prev]; // clone array
          updated[0] = {
            ...updated[0],
            methodName: cashItem[0]?.type_name,
            payment_type_id: cashItem[0]?.id,
            payment_type_category_id: cashItem[0]?.payment_type_category[0]?.id
          };
          return updated;
        });
        console.log("cashItem....... ", cashItem)
        console.log("payemtnForm....... ", paymentForm)
        console.log("1st payment data: ", response?.data?.data?.data[0])
        console.log("payment list: ", response?.data?.data?.data)
      }
    })
    .catch((error) => {
      navigate('/login');
      console.log(error);
    });
  };

  useEffect(()=>{
    console.log("Payment Form... ",paymentForm)
  },[paymentForm])

  const getPaymentAccountList = () => {
    loadingCallback(true)
    axios.get(
      `${process.env.REACT_APP_API_URL}payment-type-category-list`,{
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {

      if(response?.data.success){
        loadingCallback(false)
        setPaymentAccountList(response?.data?.data?.data);
        console.log(response?.data?.data?.data)
      }
    })
    .catch((error) => {
      navigate('/login');
      console.log(error);
    });
  };

  useEffect(()=>{
    getPayment();
    getPaymentAccountList();
  },[])


  // const handlePaymentSubmit = (e) =>{
  //   e.preventDefault();
  //   const uniqueNamesMap = new Set();

  //   const uniqueMap = paymentForm.reduce((acc, t) => {
  //     const key = `${t.payment_type_category_id}_${t.payment_type_id}`;

  //     if (!uniqueNamesMap.has(key) && Number(t.Amount)>=0 ) {
  //       uniqueNamesMap.add(key);

  //       const total = paymentForm.reduce((innerAcc, item) => {
  //         if (
  //           t.payment_type_category_id === item.payment_type_category_id &&
  //           t.payment_type_id === item.payment_type_id && Number(item.Amount)>0
  //         ) {
  //           return innerAcc + (Number(item.Amount));
  //         } else {
  //           return innerAcc;
  //         }
  //       }, 0);

  //       console.log("total Amount:", total);
  //       acc.push({ ...t, Amount: total });
  //     }

  //     return acc;
  //   }, []);

  //   console.log("patmentList", uniqueMap);

  //   const totalAmount = uniqueMap.reduce((acc, item) => {
  //     return acc + Number(item.Amount);
  //   }, 0);
  //   console.log(totalAmount);
  //   setPaidAmount(totalAmount);

  //   //setSelectedPaymentAccountList(uniqueMap)
  //   //setShowModal(!isOpen)
  // }

  const handleAddMethod = async () =>{
    if(paymentData.length<paymentList.length){
      const selectedAccount = paymentList.find(
        (method) => method.type_name.toLowerCase() === "cash"
      );
      setPaymentData([...paymentData, selectedAccount])
      const newArray = [...paymentForm];
      let data = {
        methodName: selectedAccount.type_name,
        payment_type_id: selectedAccount.id,
        payment_type_category_id: selectedAccount.payment_type_category[0].id
      }
      setPaymentForm([...paymentForm, data])
    }
  }

  const handleCancelMethod = (id, par) => {
    if(paymentData.length>1){
      const indexToRemove = paymentData.findIndex((item, index) => index === par);
      if (indexToRemove !== -1) {
        const newData = [...paymentData];
        newData.splice(indexToRemove, 1);
        setPaymentData(newData);
      }
      const indexToRemove2 = paymentForm.findIndex((item, index) => index === par);
      if (indexToRemove2 !== -1) {
        const newData2 = [...paymentForm];
        newData2.splice(indexToRemove2, 1);
        setPaymentForm(newData2);
      }
    }
  };

  const handleChangeSelect = (name, option) => {
    const { value, label } = option;
      console.log("Option", name, option);
      console.log("PaymentList", paymentAccountList, paymentList);
      if (name === 'payment_id') {
        if (label != 'Select Payment' && value) {
          setPaymentForm((prevFormData) => ({
            ...prevFormData,
            method_id: '',
            account_number: "",
          }));
          const selectedMethodObject = paymentList.find(
            (method) => method.id === value
          );
          if (selectedMethodObject) {
            setFilteredAccountList(selectedMethodObject.payment_type_category || []);
          } else {
            setFilteredAccountList([]);
          }
          const newArray = [...paymentData];
          newArray[methodIndex] = selectedMethodObject;
          setPaymentData(newArray);
          console.log("payment form inside... change ",paymentForm)
          const newArray2 = [...paymentForm];
          console.log("newArray2......before change ",newArray2)
          newArray2[methodIndex] = {
            payment_type_id: value,
            methodName: label,
            Amount: totalPaymentAmount
          }
          console.log("newArray2......after change ",newArray2)

          setPaymentForm(newArray2);
        }
        if (label == 'Select Payment') {
          setPaymentForm((prevFormData) => ({
            ...prevFormData,
            account_id: '',
            account_number: "",
          }));
        }
      }
      else if(name=='account_id'){
        if (label == 'Select Account') {
          setFormData((prevFormData) => ({
            ...prevFormData,
            account_id: '',
            account_number: "",
          }));
          const newArray = [...paymentForm];
          newArray[methodIndex] = {
            account_number: "",
            accountName: "",
            payment_type_category_id: ''
          }
          setPaymentForm(newArray);
        }
        else{
          const selectedAccount = paymentAccountList.find(
            (method) => method.id === value
          );

          console.log("account",selectedAccount, methodIndex);
          if(selectedAccount){
            const newArray = [...paymentForm];
            newArray[methodIndex] = {...newArray[methodIndex],
              accountName: label,
              account_number: selectedAccount?.account_number,
              payment_type_category_id: value
            }
            setPaymentForm(newArray);
          }
        }
      }
   }

  const {
    loadingCallback,
    navigate,
    setShowModal,
    updateModalTitle,
    setWarningMessage,
    type,
  } = props;
  const showModalWarning = (msg, data = null) => {
    Swal.fire({
      title: msg,
      text: "",
      icon: "warning",
    });
  };
  const { state, isLoading, updateInvoiceList } = useContext(AppContext);
  const { invoiceList, invoiceSetting } = state;
  const token = localStorage.getItem("token");
  const {
    getFlashMessageStyle,
    setSuccessFlashMessage,
    flashMessage,
    setErrorFlashMessage,
  } = useFlashMessage(); // Retrieve the dispatch function from your state management library
  const [discountType, setDiscountType] = useState([]);
  const [returnDiscount, setReturnDiscount] = useState([]);
  const [returnDiscountAmount, setReturnDiscountAmount] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalQty, setTotalQty] = useState([]);
  const [remainigQty, setRemainingQty] = useState([]);
  const [totalPrice, setTotalPrice] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [singleProductPrice, setSingleProductPrice] = useState([]);
  const [returnedQty, setReturnedQty] = useState([]);
  const [returnedAmount, setReturnedAmount] = useState([]);
  const [imei, setImei] = useState([]);
  const [imeiSearch, setImeiSearch] = useState("");
  const [inputValue, setInputValue] = useState('');
  const debounceTimer = useRef(null);
  const [isChecked, setIsChecked] = useState(false);
  const handleReturnCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  console.log("Selected Invoice..... ",selectedInvoice)
  // const handleCheckAllChange = (e) => {
  //   if (e.target.checked) {
  //     setSelectedProducts(selectedInvoice.sales_details ?? []);
  //   } else {
  //     setSelectedProducts([]);
  //   }
  // };
  const handleCheckAllChange = (e) => {
    const dueAmount = Math.floor(Number(selectedInvoice.due));
    console.log("Type............. ",type)
    if(dueAmount > 0){
      FlashMessage(
        `Can't select multiple when due is present.`,
        "error"
      );
      return;
    }
    const isChecked = e.target.checked;

    if (isChecked) {
      // Select all items
      const allItems = selectedInvoice.sales_details ?? [];

      const paidAmount = Math.floor(Number(selectedInvoice.paid_amount));

      // 🚫 GUARD: Validate all IMEIs before selecting
      for (let item of allItems) {
        if (
          type !== "salesReturnList" &&
          Array.isArray(item?.product_imei) &&
          item.product_imei.length > 0
        ) {
          const imeiData = item.product_imei[0];

          if (
            imeiData?.sale_invoice_id !== null &&
            imeiData?.sale_details_id !== null
          ) {
            FlashMessage(
              `Product with IMEI ${imeiData?.imei} is already sold. Cannot return now.`,
              "error"
            );
            return; // ⛔ STOP — DO NOT SELECT ALL ITEMS
          }
        }
      }

      setSelectedProducts(allItems);

      // Apply the same logic for each state
      setImei(allItems.map((item) =>
        item?.product_imei?.[0]?.imei || null
      ));

      setReturnedQty(allItems.map((item) => item.remaining_qty ?? 0));

      if(dueAmount > 0)
      {
        setReturnedAmount(
          allItems.map((item) => {
            const itemTotal =
              (item.remaining_qty ?? 0) * Number(item.price ?? 0);

            if (dueAmount > 0) {
              return paidAmount > itemTotal
                ? paidAmount - itemTotal
                : paidAmount;
            }

            return itemTotal;
          })
        );
      } else {
        setReturnedAmount(allItems.map((item) =>
          (item.remaining_qty ?? 0) * Number(item.price ?? 0)
        ));
      }

      setRemainingQty(allItems.map((item) => Number(item.remaining_qty ?? 0)));

      setTotalQty(allItems.map((item) => Number(item.qty ?? 0)));

      setSingleProductPrice(allItems.map((item) => Number(item.price ?? 0)));

      setTotalPrice(allItems.map((item) =>
        Number(item.remaining_qty ?? 0) * Number(item.price ?? 0)
      ));

      // SET DISCOUNT TYPE AS "fixed" FOR ALL ROWS
      setDiscountType(allItems.map(() => "fixed"));

      // SET DISCOUNT VALUE = 0 FOR ALL ROWS
      setReturnDiscount(allItems.map(() => 0));
    } else {
      // Deselect all items and reset related state arrays
      setSelectedProducts([]);
      setImei([]);
      setReturnedQty([]);
      setReturnedAmount([]);
      setRemainingQty([]);
      setTotalQty([]);
      setSingleProductPrice([]);
      setTotalPrice([]);
      // Reset discounts
      setDiscountType([]);
      setReturnDiscount([]);
    }
  };

  const isAllChecked =
    selectedProducts.length === selectedInvoice?.sales_details?.length &&
    selectedProducts.length > 0;

  const handleCheckboxChange = (item, index) => {
    console.log("item inside select... ... ",item)
    console.log("index inside select... ... ",index)
    const dueAmount = Math.floor(Number(selectedInvoice.due));
    const paidAmount = Math.floor(Number(selectedInvoice.paid_amount));
    const isSelected = selectedProducts.some((p) => p?.id === item?.id);

    const validSelectedCount = selectedProducts.filter(Boolean).length;
    console.log("isselected... ",isSelected)

    // how many will be selected AFTER this click
    const nextSelectedCount = isSelected
      ? validSelectedCount - 1
      : validSelectedCount + 1;

    if (dueAmount > 0 && nextSelectedCount > 1) {
      FlashMessage(
        "Can't select multiple when due is present.",
        "error"
      );

      if(isSelected){
        // If already selected, remove it
        setSelectedProducts(prev => {
          const updated = [...prev];
          updated[index] = null;
          return updated;
        });

        setReturnedQty(prev => {
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });

        setReturnedAmount(prev => {
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });

        setRemainingQty(prev => {
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });

        setTotalQty(prev => {
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });

        setSingleProductPrice(prev => {
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });

        setTotalPrice(prev => {
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });

        setImei(prev => {
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        });
      }

      return;
    }


    if (isSelected) {
      // If already selected, remove it
      setSelectedProducts(prev => {
        const updated = [...prev];
        updated[index] = null;
        return updated;
      });

      setReturnedQty(prev => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      setReturnedAmount(prev => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      setRemainingQty(prev => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      setTotalQty(prev => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      setSingleProductPrice(prev => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      setTotalPrice(prev => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      setImei(prev => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

    } else {
      console.log("inside else handelcheck... ")

      // 🚫 CHECK IF PRODUCT IMEI IS ALREADY SOLD
      if (
        type !== "salesReturnList" &&
        Array.isArray(item?.product_imei) &&
        item.product_imei.length > 0
      ) {
        const imeiData = item.product_imei[0];

        if (
          imeiData?.sale_invoice_id !== null &&
          imeiData?.sale_details_id !== null
        ) {
          FlashMessage(
            "This product is already sold. It cannot be returned now.",
            "error"
          );
          return; // ⛔ STOP HERE — DO NOT PROCESS FURTHER
        }
      }


      // If not selected, add it
      setSelectedProducts(prev => {
        const updated = [...prev];
        updated[index] = item;
        return updated;
      });

      // ⭐ DEFAULT DISCOUNT TYPE = FIXED ⭐
      setDiscountType(prev => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = "fixed";
        return updated;
      });

      setReturnDiscount(prev => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = 0;
        return updated;
      });
      console.log("inside else handelcheck after prev... ")
      // Add the IMEI if it exists
      if (
        item?.product_imei.length > 0 &&
        Array.isArray(item.product_imei) &&
        item.product_imei[0]?.imei
      ) {
        setImei((prevImei) => {
          const updatedImei = Array.isArray(prevImei) ? [...prevImei] : [];
          updatedImei[index] = item?.product_imei?.[0]?.imei || null;
          return updatedImei;
        });
      }

      // Returned Quantity
      setReturnedQty((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = item.remaining_qty;
        return updated;
      });

      // Returned Amount
      if(dueAmount > 0){
        setReturnedAmount((prev) => {
          const updated = Array.isArray(prev) ? [...prev] : [];

          const itemTotal =
            (item.remaining_qty ?? 0) * Number(item.price ?? 0);

          updated[index] =
            dueAmount > 0
              ? paidAmount > itemTotal
                ? paidAmount - itemTotal
                : paidAmount
              : itemTotal;

          return updated;
        });
      } else {
        setReturnedAmount((prev) => {
          const updated = Array.isArray(prev) ? [...prev] : [];
          updated[index] = item.remaining_qty * Number(item.price);
          return updated;
        });
      }


      // Remaining Quantity
      setRemainingQty((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = Number(item.remaining_qty);
        return updated;
      });

      // Total Quantity
      setTotalQty((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = Number(item.qty);
        return updated;
      });

      // Single Product Price
      setSingleProductPrice((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = Number(item.price);
        return updated;
      });

      // Total Price
      setTotalPrice((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = Number(item.remaining_qty) * Number(item.price);
        return updated;
      });
    }

  }

  useEffect(() => {
    totalAmount = returnedAmount
    .filter(val => typeof val === "number" && !isNaN(val))
    .reduce((sum, val) => sum + val, 0);
    setTotoalPaymentAmount(totalAmount);
    console.log("paymentForm... ", paymentForm);
    setPaymentForm((prev) =>
      prev.map((item, index) =>
        index === 0 ? { ...item, Amount: totalAmount } : item
      )
    );
    console.log('return amount', returnedAmount)
    console.log('total amount', totalAmount)
  }, [returnedAmount]);

  useEffect(() => {
  }, [showPayment]);

  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 20;
  const [showModalDescription, setShowModalDescription] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    getInvoicelist(type, searchKeyword);
  }, [type, searchKeyword, productSelect]);
  const [filteredInvoice, setFilteredInvoice] = useState([]);
  const getInvoicelist = async (type) => {
    loadingCallback(true);

    if (searchKeyword !== "" || productSelect !== "") {
      setFilteredInvoice([{ id: "", name: "Select Invoice" }]);
      const page = 1;
      const reqData = { keyword: searchKeyword, product_id: productSelect };
      const url =
        type === "salesReturnList"
          ? `search-invoice`
          : `search-purchase-invoice`;
      post(url, reqData, token)
        .then((response) => {
          //loadingCallback(false);
          const options = [];
          if (response.status === 200) {
            const listData = response.data.data;
            if (listData.length > 0) {
              const invoiceOptions = listData.map((item) => ({
                id: item.id,
                //icon: <RiMoneyDollarCircleLine/>,
                name: item.invoice_id,
                //sname: item.customer_name,
                sales_details:
                  type === "salesReturnList"
                    ? item.sales_details
                    : item.purchase_details,
                price: formatPrice(
                      invoiceCalculate(
                        item,
                        type === "salesReturnList" ? "sales" : "purchase"
                      ).grandTotal
                    ),
                paid_amount: formatPrice(
                      invoiceCalculate(
                        item,
                        type === "salesReturnList" ? "sales" : "purchase"
                      ).paidDue),
                due: formatPrice(
                      invoiceCalculate(
                        item,
                        type === "salesReturnList" ? "sales" : "purchase"
                      ).dueAmount),
                //time: timeDiff(new Date(item.updated_at)),
                colors: "#00A3EE",
                created_at: item.created_at,
              }));
              options.push(...invoiceOptions);
            } else {
              console.log("Data Not Found!");
            }
            setFilteredInvoice(options);
            loadingCallback(false);
          }
          loadingCallback(false);
        })
        .catch((error) => {
          loadingCallback(false);
          console.log(error);
          if (error?.response?.status === 401) {
            localStorage.clear();
            localStorage.setItem("token", false);
            // Clear session and local storage
            localStorage.setItem("isPinVerify", false);

            navigate("/login");
          }
        });
    } else {
      const url =
        type === "salesReturnList"
          ? `invoice-list?page=1&limit=20`
          : `purchase-invoice-list?page=1&limit=20`;
      setFilteredInvoice([]);
      get(url, token)
        .then((response) => {
          //loadingCallback(false);
          const options = [];
          if (response.data.data) {
            const listData = response.data.data;

            if (listData.length > 0) {
              const invoiceOptions = listData.map((item) => ({
                id: item.id,
                //icon: <RiMoneyDollarCircleLine/>,
                name: item.invoice_id,
                //sname: item.customer_name,
                sales_details:
                  type === "salesReturnList"
                    ? item.sales_details
                    : item.purchase_details,
                price: formatPrice(
                        invoiceCalculate(
                          item,
                          type === "salesReturnList" ? "sales" : "purchase"
                        ).grandTotal),
                paid_amount: formatPrice(
                      invoiceCalculate(
                        item,
                        type === "salesReturnList" ? "sales" : "purchase"
                      ).paidDue),
                due: formatPrice(
                      invoiceCalculate(
                        item,
                        type === "salesReturnList" ? "sales" : "purchase"
                      ).dueAmount
                    ),
                //time: timeDiff(new Date(item.updated_at)),
                colors: "#00A3EE",
                created_at: item.created_at,
              }));
              options.push(...invoiceOptions);
            } else {
              console.log("Data Not Found!");
            }
            setFilteredInvoice(options);
            loadingCallback(false);
          }
          loadingCallback(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const onPageChange = (page) => {
    setCurrentPage(page);
  };
  const shouldRenderPagination = invoiceList.total > perPage;

  //const handleShowModal = () => setShowModalDescription(true);
  const handleShowModal = () => {
    updateModalTitle("Return Description");
    setShowModalDescription(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const totalMultiplePaymentAmount = paymentForm.reduce(
      (sum, item) => sum + Number(item.Amount || 0),
      0
    );

    console.log("totalMultiplePaymentAmount.... ",totalMultiplePaymentAmount)
    console.log("totalPaymentAmount.... ",totalPaymentAmount)
    if (totalMultiplePaymentAmount !== Number(totalPaymentAmount)) {
      FlashMessage(
        "Payment amount can't be greater or smaller than return amount",
        "error"
      );
      return; // stop further execution if needed
    }

    const hasMissingAccount = paymentForm.some((p) =>
      p.methodName !== "Cash" && p.payment_type_category_id == null
    );

    if (hasMissingAccount) {
      FlashMessage("Please select an account first", "error");
      return;
    }
    const formData = new FormData(event.target);
    const formObject = {};
    console.log("Returnedamount in submit.. ",returnedAmount)
    console.log("Returnedqty in submit.. ",returnedQty)
    console.log("imei in submit.. ",imei)
    const totalAmount = returnedAmount.filter(val => typeof val === "number" && !isNaN(val))
    .reduce((sum, val) => sum + val, 0);
    formObject.return_amount = totalAmount;

    const totalQty = returnedQty.filter(val => typeof val === "number" && !isNaN(val)).reduce((sum, val) => sum + val, 0);
    formObject.return_qty = totalQty;

    formData.forEach((value, key) => {
      formObject[key] = value;
    });
    if (type === "salesReturnList") {
      formObject.return_stock_status = isChecked ? 1 : 0;
    }
    if (selectedInvoice) {
      formObject.invoice_id = selectedInvoice.name;
    }

    formObject.return_amount = totalAmount;
    formObject.return_qty = totalQty;

    const transformedProductArray = selectedProducts
      .map((item, index) =>
        item && {
          product_id: item?.product_id,
          product_variant_id: item?.product_variant?.id,
          product_item_id: item?.product_item?.id,
          return_qty: returnedQty[index],
          return_amount: totalAmount,
          discount: returnDiscountAmount[index] ?? 0,
          return_unit_price: item?.price,
          return_stock_status: isChecked ? 1 : 0,
          details_id: item?.id,
          imei: imei[index],
        }
      )
      .filter(Boolean);
    formObject.product = transformedProductArray;
    formObject.multiple_payment = paymentForm;
    // console.log("============");
    // console.log(formObject);
    // console.log(selectedProducts);
    console.log("formObject........... ",formObject);
    console.log("Return Reaaaaaaaaaaaaaaaaaaaaaaaached........... ");

    //loadingCallback(true);

    const url =
      type === "salesReturnList" ? `save-sales-return` : `save-purchase-return`;
    post(url, formObject, token)
      .then((response) => {
        loadingCallback(false);
        if (response.status === 200) {
          //setCustomer(response.data);
          setShowModal(false);
          setShowModalDescription(false);
          setShowPayment(false);
          // setSuccessFlashMessage('invoice returned successfully');
          FlashMessage("invoice returned successfully", "success");
        } else {
          console.log("invoice return failed");
          // setErrorFlashMessage('invoice return failed');
          FlashMessage("invoice return failed", "error");
          setWarningMessage(true);
          const timer = setTimeout(() => {
            setWarningMessage(false);
          }, 3000);
          return () => clearTimeout(timer);
        }
      })
      .catch((error) => {
        loadingCallback(false);
        if (error?.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          // Clear session and local storage
          localStorage.setItem("isPinVerify", false);

          navigate("/login");
        }
        console.log(error);
      });
  };

  const handleInvoiceSelect = (event) => {
    console.log(event);
    // if (event.target.value === "") {
    //     setSelectedInvoice(null);
    //     return;
    // }
    if (event.value === "") {
      // setSelectedInvoice(null);
      return;
    }

    /*Previous data reset*/
    setSelectedInvoice(null);
    setSelectedProducts([]);
    setTotalQty(0);
    setTotalPrice(0);

    // const invoiceId = parseInt(event.target.value);
    // const selectedInvoiceData = filteredInvoice.find((invoice) => invoice.id === invoiceId);
    // setSelectedInvoice(selectedInvoiceData);
    const invoiceId = parseInt(event.value);
    console.log("invoice ID... ",invoiceId)
    const selectedInvoiceData = filteredInvoice?.find(
      (invoice) => invoice.id === invoiceId
    );
    setSelectedInvoice(selectedInvoiceData);
    // setShowNewCustomerForm(false);
    // // Update the value of the input field
    // if (selectedCustomer.district) {
    //     getCityList(selectedCustomer.district);
    // }
  };

  const backModalDescription = () => {
    if(showPayment){
      setShowPayment(false);
    }
    else{
      setShowModalDescription(false);
    }

  };

  const showPymentModal = () => {
    setShowPayment(true);
  };

  useEffect(() => {
    getProductList(currentPage);
  }, [currentPage, searchProdFilter]);

  const getProductList = (page) => {
    if (searchProdFilter.keyword !== "") {
      const reqData = { keyword: searchProdFilter.keyword };
      const data = {
        keyword: searchProdFilter.keyword,
      };
      loadingCallback(true);
      post(`search-product-v1?page=${page}&limit=${perPage}`, data, token)
        .then((response) => {
          loadingCallback(false);
          if (response.status === 200) {
            const listData = response.data.data;
            // setProductData(response.data)
            // setProductTotal(listData.length)
            setProductListSelect(listData);
            console.log("product names after search", listData);

            const transformedProductArray = listData.map((item) => ({
              id: item.id,
              name: item.name,
            }));
            //updateProductList(transformedProductArray)
          }
        })
        .catch((error) => {
          loadingCallback(false);
          console.log(error);
          localStorage.clear();
          localStorage.setItem("token", false);
          localStorage.setItem("isPinVerify", false);
          console.log("error", error);
          navigate("/login");
        });
    } else {
      loadingCallback(true);
      get(`product?page=${page}&limit=${perPage}`, token)
        .then((response) => {
          loadingCallback(false);
          if (response?.data?.data) {
            const listData = response?.data?.data;
            // setProductData(response.data)
            // setProductTotal(listData.length)
            setProductListSelect(listData);
            console.log("product names before search", listData);
            const transformedProductArray = listData.map((item) => ({
              id: item.id,
              name: item.name,
            }));
            //updateProductList(transformedProductArray)
          }
        })
        .catch((error) => {
          loadingCallback(false);
          console.log("Full error object:", error);

          if (error.response) {
            console.log("Error response data:", error.response.data);
            console.log("Error response status:", error.response.status);
            console.log("Error response headers:", error.response.headers);

            if (error.response.status === 401) {
              localStorage.clear();
              localStorage.setItem("token", false);
              localStorage.setItem("isPinVerify", false);
              navigate("/login");
            } else {
              // Other error handling based on status or data
              console.error("Other API Error:", error.response.data);
            }
          } else {
            // Handle errors without a response (e.g., network issues)
            console.error("Network or other error:", error.message);
          }
        });
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value); // updates immediately for the input

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setImeiSearch(value); // updates after 700ms pause
    }, 700);
  };

  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  useEffect(() => {
    getSaleInvoiceFromImei();
  },[imeiSearch])

  const getSaleInvoiceFromImei = () => {
    console.log("imeiSearch.......... ",imeiSearch)
      loadingCallback(true);
      post(`get-imei-with-imei`,{imei: imeiSearch},token)
        .then((response) => {
          loadingCallback(false);
          console.log("imeiSearch Response... ",response.data)
          let invoiceNumber = 0;

          if(type === "salesReturnList"){
            const fullInvoiceId = response?.data[0]?.sale_invoice_id;
            invoiceNumber = fullInvoiceId?.split('-').pop();
          } else {
            invoiceNumber = response?.data[0]?.purchase_id;
          }
          console.log("invoiceNumber... ",invoiceNumber)
          console.log("filteredInvoice... ",filteredInvoice)
          const selectedInvoiceData = filteredInvoice?.find(
            (invoice) => invoice.id == invoiceNumber
          );
          console.log("selected...invoice... ",selectedInvoiceData)
          setSelectedInvoice(selectedInvoiceData);
        })
        .catch((error) => {
          loadingCallback(false);
          console.log("Full error object:", error);

          if (error.response) {
            console.log("Error response data:", error.response.data);
            console.log("Error response status:", error.response.status);
            console.log("Error response headers:", error.response.headers);

            if (error.response.status === 401) {
              localStorage.clear();
              localStorage.setItem("token", false);
              localStorage.setItem("isPinVerify", false);
              navigate("/login");
            } else {
              // Other error handling based on status or data
              console.error("Other API Error:", error.response.data);
            }
          } else {
            // Handle errors without a response (e.g., network issues)
            console.error("Network or other error:", error.message);
          }
        });
  }

  const [selectedIds, setSelectedIds] = useState([]); // store IDs (stable)
  const checkAllRef = useRef(null);

  // Keep selectedIds valid when invoice changes (remove ids that don't exist anymore)
  useEffect(() => {
    const allIds = (selectedInvoice?.sales_details || []).map((i) => i.id);
    setSelectedIds((prev) => prev.filter((id) => allIds.includes(id)));
  }, [selectedInvoice?.sales_details]);

  // Set header checkbox indeterminate state when some but not all selected
  useEffect(() => {
    if (!checkAllRef.current) return;
    const total = (selectedInvoice?.sales_details || []).length;
    checkAllRef.current.indeterminate =
      selectedIds.length > 0 && selectedIds.length < total;
  }, [selectedIds, selectedInvoice?.sales_details]);

  useEffect(() => {
    console.log("returned quantity ... ", returnedQty);
    console.log("returned amount ... ", returnedAmount);
    console.log("imei ... ", imei);
    console.log("return discount amount ... ", returnDiscountAmount);
    console.log("return discount ... ", returnDiscount);

  },[returnedQty,returnedAmount,returnDiscountAmount,returnDiscount])
  return (
    <form
      method="get"
      className="col-sm-12 min-h-[40vh]"
      data-autosubmit="false"
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <ToastContainer />
      {!showModalDescription ? (
        <div className="flex flex-col">
          {/* <div className="flex flex-row mb-3">
                        <input
                            autoFocus
                            type="text"
                            id="invoiceSearch"
                            name="invoiceSearch"
                            className="bg-[#F1F1FA] rounded-[11px] w-[100%] pt-[14px] pr-[28px] pl-[35px] pb-[12px] placeholder:text-[#91919F] placeholder:text-[14px] focus:outline-none"
                            placeholder="Search Invoice"
                            value={searchKeyword}
                            onChange={(e) => {
                                setSearchKeyword(e.target.value);
                            }}
                        />
                    </div>


                    {filteredInvoice && filteredInvoice.length > 0 && (
                        <div className="flex flex-row mb-3">

                            <div className="w-full d-flex align-items-center">
                                <select
                                    id="invoice_id"
                                    name="invoice_id"
                                    className={classNames(
                                        'w-full',
                                        'rounded-[15px]',
                                        'p-3',
                                        'bg-white'
                                    )}
                                    style={{  border: "1px solid #ccc" }}
                                    onChange={handleInvoiceSelect}
                                    value={selectedInvoice ? selectedInvoice.id : ""}
                                >
                                    {filteredInvoice && filteredInvoice.map((invoice) => (
                                        <option key={invoice.id} value={invoice.id}>
                                            {invoice.name}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>
                    )} */}

          <div className="mb-3">
            <label htmlFor="invoiceSelect" className="form-label">
              Select Invoice
            </label>

            <div className="d-flex align-items-center">
              <SelectBox
                name="invoice_id"
                options={filteredInvoice}
                onChange={handleInvoiceSelect}
                value={selectedInvoice ? selectedInvoice.id : ""}
                onInputChangeData={(inputText) => setSearchKeyword(inputText)}
                placeholder="Select Invoice"
                className={classNames("w-full", "rounded-[15px]", "bg-white")}
              />
            </div>
          </div>

          <div className="mb-3">
            <div className="w-[100%] mt-[.7rem] relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                IMEI
              </label>
              <input
                type="text"
                name="imei"
                placeholder="Search IMEI"
                value={inputValue}
                onChange={handleChange}
                className={`py-[10px] px-[10px] w-full rounded-xl bg-white border-2 focus:border-sky-600 !focus:border-sky-600`}
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="invoiceSelect" className="form-label">
              Select Product
            </label>

            <div className="d-flex align-items-center">
              {console.log("products ", productListSelect)}
              <SelectImei
                name="product_name"
                options={productListSelect}
                value={productListSelect[0]}
                label={"Product"}
                placeholder="Select Product"
                onChange={(e) => {
                  console.log("products onchange ", e.id);
                  setProductSelect(e.id);
                }}
                onInputChangeData={(input) => {
                  setSearchProdFilter({ ...searchProdFilter, keyword: input });
                }}
              />
            </div>
          </div>

          {selectedInvoice && (
            <>
              {(() => {
                // Enclose the block of code in an IIFE (Immediately Invoked Function Expression)
                const invoiceDate = new Date(selectedInvoice.created_at);
                const year = invoiceDate.getFullYear();
                const month = String(invoiceDate.getMonth() + 1).padStart(
                  2,
                  "0"
                );
                const day = String(invoiceDate.getDate()).padStart(2, "0");
                const hours = String(invoiceDate.getHours() % 12).padStart(
                  2,
                  "0"
                );
                const minutes = String(invoiceDate.getMinutes()).padStart(
                  2,
                  "0"
                );
                const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM";

                //const shop_logo = `${BASE_URL}/layoutlogo.svg`;
                const formattedDate = `${year}-${month}-${day}`;
                const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`;
                console.log("selectedInvoice.................... ",selectedInvoice)
                //const paidDue = selectedInvoice
                // let totalPrice = 0;
                // let totalQty = 0;
                // You can perform any desired operations with the declared variables here
                return (
                  <>
                    <div className="border-1 border-solid border-[#F1F1FA] rounded-[15px] px-[16px] py-[12px] flex flex-col">
                      <div className="flex flex-row justify-between mb-[16px]">
                        <div className="text-[#000232] text-[12px] font-bold font-lato">
                          {type === "salesReturnList"
                            ? "Sold Product List"
                            : "Purchased Product List"}
                        </div>
                        <div className="text-[#000232] text-[12px] font-500 font-lato">
                          Date : {formattedDateTime}
                        </div>
                      </div>

                      <div className="flex flex-col">
                        {/* Header row */}
                        <div className="text-[#000232] text-[12px] font-bold mb-[10px] flex flex-row">
                          <div className="text-left w-[30%] flex items-center gap-2">
                            {/* ✅ Check All Checkbox */}
                          <input
                            type="checkbox"
                            className="rounded-[6px]"
                            checked={isAllChecked}
                            onChange={handleCheckAllChange}
                          />
                            Product Name
                          </div>
                          <div className="text-left w-[30%]">Unit Price</div>
                          <div className="text-center w-[10%]">Qty</div>
                          <div className="text-right w-[30%]">Total Amount</div>
                        </div>

                        {/* Rows */}
                        {selectedInvoice.sales_details.map((item, index) => {
                          const subtotalPrice = formatPrice(item.qty * item.price);

                          const imei =
                            item?.product_imei &&
                            Array.isArray(item.product_imei) &&
                            item.product_imei[0]?.imei
                              ? item.product_imei[0]?.imei
                              : "";

                          return (
                            <div
                              key={item.id}
                              className="border-t-[1px] border-solid py-[11px] border-[#E7EBF4] flex flex-row gap-1 md:gap-2"
                            >
                              <div className="w-[30%] flex flex-row items-center gap-2">
                                <input
                                  type="checkbox"
                                  checked={selectedProducts.some((p) => p?.id === item?.id)}
                                  onChange={() => handleCheckboxChange(item,index)}
                                />
                                {console.log("items.......", item)}
                                <div className="flex flex-col justify-left items-left">
                                  <label className="text-[#000232] text-[14px] font-nunito font-400">
                                    {item?.product_info?.name} {item?.product_variant?.name}{item?.product_item?.sku}{item?.product_item?.attributes?.length > 0 && (
                                                <>
                                                  {" - "}
                                                  {item.product_item.attributes
                                                    .map(attr => attr.attribute_value?.value)
                                                    .join(" - ")}
                                                </>
                                              )}
                                  </label>
                                  <label className="text-[#000232] text-[12px] font-nunito font-100 mt-1">
                                    {imei}
                                  </label>
                                </div>
                              </div>
                              <div className="w-[30%] text-[#000232] text-[12px] font-nunito font-400">
                                {item.price}
                              </div>
                              <div className="w-[10%] text-[#000232] text-[12px] font-nunito font-400 text-center">
                                {item?.remaining_qty ? item?.remaining_qty : item?.qty}
                              </div>
                              <div className="w-[30%] text-[#000232] text-[14px] font-nunito font-400 text-right">
                                {subtotalPrice} BDT
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <input
                      onClick={handleShowModal}
                      type="submit"
                      className="w-full mt-[25px] bg-[#034AFF] text-[18px] text-[#FCFCFC] py-[6px] rounded-[16px] font-nunito font-600"
                      name="order"
                      value="Next"
                    />
                  </>
                );
              })()}
            </>
          )}
        </div>
      ) : (
        <div className="flex flex-col">
          {selectedInvoice && (
            <>
              {(() => {
                // Enclose the block of code in an IIFE (Immediately Invoked Function Expression)
                const invoiceDate = new Date(selectedInvoice.created_at);
                const year = invoiceDate.getFullYear();
                const month = String(invoiceDate.getMonth() + 1).padStart(
                  2,
                  "0"
                );
                const day = String(invoiceDate.getDate()).padStart(2, "0");
                const hours = String(invoiceDate.getHours() % 12).padStart(
                  2,
                  "0"
                );
                const minutes = String(invoiceDate.getMinutes()).padStart(
                  2,
                  "0"
                );
                const ampm = invoiceDate.getHours() >= 12 ? "PM" : "AM";

                //const shop_logo = `${BASE_URL}/layoutlogo.svg`;
                const formattedDate = `${year}-${month}-${day}`;
                const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`;
                //let totalPrice = 0;
                //let totalQty = 0;
                {
                  selectedInvoice.sales_details.map((item) => {
                    //totalQty += Number(item.qty);
                    const subtotalPrice = formatPrice(item.qty * item.price);
                    //totalPrice += Number(subtotalPrice);
                  });
                }
                // You can perform any desired operations with the declared variables here
                return (
                  <>
                    {/* <textarea
                      className="bg-white border-1 border-solid border-[#F1F1FA] min-h-[110px] py-[10px] px-[16px] rounded-[15px] focus:outline-none"
                      placeholder="Return Description"
                      name="return_description"
                    ></textarea> */}
                    {console.log("selectedInvoice ", selectedInvoice)}
                    {console.log("selectedProducts ", selectedProducts)}
                   {/* <div>
                    <div className="flex flex-row gap-3 mt-[16px]">
                      <div className="flex-1 flex flex-row justify-between px-[16px] py-[19px] border-1 border-solid border-[#F1F1FA] rounded-[15px]">
                        <div className="text-[#000232] text-[14px] font-500">
                          Purchase Qty
                        </div>
                        <input
                          type="text"
                          className="bg-white border-none w-[30px] focus:outline-none"
                          placeholder=""
                          value={totalQty}
                        />
                      </div>
                      <div className="flex-1 flex flex-row justify-between px-[16px] py-[19px] border-1 border-solid border-[#F1F1FA] rounded-[15px]">
                        <div className="text-[#000232] text-[14px] font-500">
                          Return Qty
                        </div>
                        {console.log("returnedQty ", returnedQty)}
                        {console.log("remainigQty ", remainigQty)}
                        <input
                          type="text"
                          name="return_qty"
                          className="bg-white w-[49px] border-1 border-solid border-[#000232] rounded-[4px] focus:outline-none"
                          placeholder=""
                          onChange={(e) => {
                            e.preventDefault();
                            // Validate input to allow only numbers
                            const inputValue = e.target.value;
                            const onlyNumbers = inputValue.replace(
                              /[^0-9]/g,
                              ""
                            ); // Remove non-numeric characters
                            if (onlyNumbers > remainigQty) {
                              setReturnedQty(remainigQty);
                              setReturnedAmount(
                                remainigQty * singleProductPrice
                              );
                              setTotalPrice(remainigQty * singleProductPrice);
                              toast.warn(
                                "Return quantity can not exceed remaining quantity",
                                {
                                  position: "top-right",
                                  autoClose: 3000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                }
                              );
                              return;
                            }
                            handleQtyChange(onlyNumbers);
                          }}
                          value={Number(
                            returnedQty !== null ? returnedQty : remainigQty
                          )} // Use the updated value in the input field
                        />
                      </div>
                    </div>

                    <div className="flex flex-row items-center gap-3 mt-[16px]">
                      <input
                        type="text"
                        name="return_amount"
                        className="bg-white w-[70%] border-1 border-solid border-[#F1F1FA] rounded-[15px] py-[18px] px-[16px] focus:outline-none"
                        placeholder="Return Amount"
                        onChange={(e) => {
                          e.preventDefault();
                          setReturnedAmount(
                            e.target.value ? e.target.value : ""
                          );
                        }}
                        value={
                          returnedAmount !== null ? returnedAmount : totalPrice
                        }
                      />
                      <div className="flex-1 text-[24px] text-[#000232] font-bold font-nunito text-right">
                        {totalPrice} BDT
                      </div>
                    </div>
                    {type === "salesReturnList" && (
                      <div className="flex flex-row items-center gap-2 mt-[16px]">
                        <input
                          type="checkbox"
                          name="status"
                          id="return_stock"
                          checked={isChecked}
                          onChange={handleReturnCheckboxChange}
                        />
                        <label
                          for="return_stock"
                          className="text-[#91919F] text-[16px] font-nunito font-400"
                        >
                          Return to Stock
                        </label>
                      </div>
                    )}
                  </div> */}
                    { showPayment ?
                            <>
                              <div
                              className="col-sm-12 min-h-[10vh]"
                              >
                                <div className="duration-500">
                                  <div class="flex flex-row justify-between items-center py-3 px-1">
                                    <h1 class="text-md font-semibold font-lato pb-1 px-1">Return Amount</h1>
                                    <div class="">
                                      <p class="text-sm px-[4px] py-[2px]">{totalPaymentAmount}</p>
                                    </div>
                                  </div>
                                  {paymentData.map((item, index) => (
                                    <div key={index} className="">
                                      <div className="flex flex-row justify-between items-center py-3 px-1">
                                        <h1 className="text-md font-semibold font-lato pb-1 px-1">
                                          {item.type_name}
                                        </h1>
                                        {index != 0 && (
                                          <div
                                            className="bg-red-600 text-white rounded-md cursor-pointer"
                                            onClick={() => handleCancelMethod(item.id, index)}
                                          >
                                            <p className="text-sm px-[4px] py-[2px]">Cancel</p>
                                          </div>
                                        )}
                                      </div>
                                      <div
                                        className="flex items-center justify-center py-3 gap-3"
                                        onClick={() => setMethodIndex(index)}
                                      >
                                        <ItemSelectBox
                                          name="payment_id"
                                          options={paymentList}
                                          value={paymentForm.payment_type_id}
                                          onChange={handleChangeSelect.bind(this, "payment_id")}
                                          label={"Method Name"}
                                          placeholder={item.type_name}
                                          style={{ maxHeight: "300px", overflowY: "scroll" }}
                                        />
                                      </div>
                                      {item.type_name.toLowerCase() != "cash" && (
                                        <>
                                          <div
                                            className="flex items-center justify-center py-3 gap-3"
                                            onClick={() => setMethodIndex(index)}
                                          >
                                            <ItemSelectBox
                                              name="account_id"
                                              options={filteredAccountList}
                                              value={paymentForm[index].account_id}
                                              label={"Account Name"}
                                              onChange={handleChangeSelect.bind(this, "account_id")}
                                              placeholder="Select Account"
                                            />
                                          </div>

                                          <div className="flex items-center justify-center py-3 gap-3">
                                            <div className="w-full relative">
                                              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                                                Account Number
                                              </label>
                                              <input
                                                key={index}
                                                type="text"
                                                name="name"
                                                disabled
                                                value={paymentForm[index].account_number}
                                                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <div className="flex items-center justify-center py-2 gap-3">
                                        <div className="w-full relative">
                                          <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[14px] left-[12px] bg-white px-1 font-semibold">
                                            Amount
                                          </label>
                                          <input
                                            key={index}
                                            type="text"
                                            name="name"
                                            placeholder="000.0"
                                            value={paymentForm[index]?.Amount}
                                            // disabled={
                                            //   item.type_name.toLowerCase() == "cash"
                                            //     ? false
                                            //     : paymentAccountAmount[index].account_number
                                            //     ? false
                                            //     : true
                                            // }
                                            onChange={(e) => {
                                              console.log("index......", index)
                                              setPaymentForm((prevAmount) => [
                                                ...prevAmount.slice(0, index),
                                                { ...prevAmount[index], Amount: e.target.value },
                                                ...prevAmount.slice(index + 1),
                                              ]);
                                            }}
                                            className="input input-bordered w-full mb-[10px] rounded-xl bg-white"
                                          />
                                        </div>
                                      </div>
                                      {paymentData.length > 1 && <hr />}
                                    </div>
                                  ))}
                                  <div className="flex flex-row justify-between items-center py-3 px-1">
                                    <div>
                                      <h1 className="text-md font-semibold font-lato">
                                        Pay with more Method
                                      </h1>
                                    </div>
                                    <div>
                                      <div
                                        onClick={handleAddMethod}
                                        className="flex justify-center items-center border-2 text-[#000] text-[18px] font-nunito font-bold py-[10px] px-[10px] cursor-pointer rounded-lg capitalize"
                                      >
                                        <i class="fa-solid fa-plus"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                  {/* <button
                                    htmlFor="my_modal_payment_info"
                                    // onClick={handleSubmit}
                                    type="submit"
                                    className="cursor-pointer w-full bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
                                  >
                                    Save
                                  </button> */}
                                </div>

                                </div>

                              </div>
                            </>
                    : (selectedProducts.map((item, index) => item && (
                      <div
                        key={item.id}
                        className="bg-white shadow rounded-xl p-3 mb-4 border border-[#E5E7EB] hover:shadow-md transition w-full max-w-full overflow-hidden"
                      >
                        {/* Product Title */}
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between border-b pb-2 mb-3 gap-1">
                          {console.log("item....... ",item)}
                          <h2 className="text-sm sm:text-base font-semibold text-[#000232] break-words">
                            {item?.product_info?.name}
                            {item?.product_variant?.name && (
                              <> ({item.product_variant.name})</>
                            )}
                          </h2>

                          {
                            item?.product_imei[0]?.imei && <span className="text-[11px] sm:text-xs text-gray-500 break-words">
                              #{item?.product_imei[0]?.imei}
                            </span>
                          }
                        </div>

                        {/* Purchase & Return Qty */}
                        <div className="flex flex-col sm:flex-row gap-3">
                          {/* Purchase Qty */}
                          <div className="flex-1 flex flex-col gap-1 border border-[#F1F1FA] rounded-lg p-2">
                            <span className="text-[#000232] text-xs font-medium">Purchase Qty</span>
                            <input
                              type="text"
                              className="bg-gray-50 border-none text-center rounded-md p-1.5 text-sm focus:outline-none w-full"
                              value={totalQty[index] ?? item?.qty}
                              readOnly
                            />
                          </div>

                          {/* Return Qty */}
                          <div className="flex-1 flex flex-col gap-1 border border-[#F1F1FA] rounded-lg p-2">
                            {console.log("Returned quantity in div... ", returnedQty[index])}
                            {console.log("Item in div... ", item)}
                            <span className="text-[#000232] text-xs font-medium">Return Qty</span>
                            <input
                              type="text"
                              name="return_qty"
                              className="bg-gray-50 border border-[#000232] rounded-md p-1.5 text-center text-sm focus:outline-none w-full"
                              value={Number(returnedQty?.[index] ?? item?.remaining_qty)}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                const onlyNumbers = inputValue.replace(/[^0-9]/g, "");

                                if (Number(onlyNumbers) > Number(item?.remaining_qty)) {
                                  setReturnedQty((prev) => {
                                    const updated = Array.isArray(prev) ? [...prev] : [];
                                    updated[index] = item?.remaining_qty;
                                    return updated;
                                  });
                                  setReturnedAmount((prev) => {
                                    const updated = Array.isArray(prev) ? [...prev] : [];
                                    updated[index] = item?.remaining_qty * Number(item?.price);
                                    return updated;
                                  });
                                  setTotalPrice((prev) => {
                                    const updated = Array.isArray(prev) ? [...prev] : [];
                                    updated[index] = item?.remaining_qty * Number(item?.price);
                                    return updated;
                                  });

                                  toast.warn("Return quantity cannot exceed remaining quantity", {
                                    position: "top-right",
                                    autoClose: 3000,
                                  });
                                  return;
                                }

                                setReturnedQty((prev) => {
                                  const updated = Array.isArray(prev) ? [...prev] : [];
                                  updated[index] = Number(onlyNumbers);
                                  return updated;
                                });

                                setReturnedAmount((prev) => {
                                  const updated = Array.isArray(prev) ? [...prev] : [];
                                  updated[index] = Number(onlyNumbers) * Number(item.price);
                                  return updated;
                                });
                                setTotalPrice((prev) => {
                                  const updated = Array.isArray(prev) ? [...prev] : [];
                                  updated[index] = Number(onlyNumbers) * Number(item.price);
                                  return updated;
                                });
                              }}
                            />
                          </div>
                        </div>

                        {/* Return Discount */}
                        <div className="flex flex-col sm:flex-row gap-3 mt-3">

                          {/* Discount Type */}
                          <div className="flex-1 flex flex-col gap-1 border border-[#F1F1FA] rounded-lg p-2">
                            <span className="text-[#000232] text-xs font-medium">Discount Type</span>
                            <select
                              className="bg-gray-50 border border-[#000232] rounded-md p-1.5 text-sm w-full"
                              value={discountType[index] ?? "percentage"}
                              onChange={(e) => {
                                const type = e.target.value;

                                setDiscountType((prev) => {
                                  const updated = [...prev];
                                  updated[index] = type;
                                  return updated;
                                });

                                // Recalculate based on current discount value
                                const qty = Number(returnedQty[index] ?? item.remaining_qty);
                                const base = qty * Number(item.price);
                                const discount = Number(returnDiscount[index] ?? 0);

                                let final = base;

                                if (type === "percentage") {
                                  setReturnDiscountAmount((prev) => {
                                    const updated = [...prev];
                                    updated[index] = (base * discount) / 100;
                                    return updated;
                                  })
                                  final = base - (base * discount) / 100;
                                } else {
                                  setReturnDiscountAmount((prev) => {
                                    const updated = [...prev];
                                    updated[index] = discount;
                                    return updated;
                                  })
                                  final = base - discount;
                                }

                                if (final < 0) final = 0;

                                setReturnedAmount((prev) => {
                                  const updated = [...prev];
                                  updated[index] = final;
                                  return updated;
                                });

                                setTotalPrice((prev) => {
                                  const updated = [...prev];
                                  updated[index] = final;
                                  return updated;
                                });
                              }}
                            >
                              <option value="percentage">Percentage (%)</option>
                              <option value="fixed">Fixed (BDT)</option>
                            </select>
                          </div>

                          {/* Discount Value */}
                          <div className="flex-1 flex flex-col gap-1 border border-[#F1F1FA] rounded-lg p-2">
                            <span className="text-[#000232] text-xs font-medium">Discount</span>
                            <input
                              type="text"
                              className="bg-gray-50 border border-[#000232] rounded-md p-1.5 text-center text-sm w-full"
                              value={returnDiscount[index] ?? ""}
                              onChange={(e) => {
                                const val = e.target.value.replace(/[^0-9.]/g, "");
                                const num = Number(val);

                                setReturnDiscount((prev) => {
                                  const updated = [...prev];
                                  updated[index] = num;
                                  return updated;
                                });

                                const qty = Number(returnedQty[index] ?? item.remaining_qty);
                                const base = qty * Number(item.price);

                                let final = base;

                                if (discountType[index] === "percentage") {
                                  if (num > 100) {
                                    toast.warn("Percentage cannot exceed 100%", { autoClose: 3000 });
                                    return;
                                  }
                                  setReturnDiscountAmount((prev) => {
                                    const updated = [...prev];
                                    updated[index] = (base * num) / 100;
                                    return updated;
                                  })
                                  final = base - (base * num) / 100;
                                } else {
                                  if (num > base) {
                                    toast.warn("Fixed discount cannot exceed return amount", { autoClose: 3000 });
                                    return;
                                  }
                                  setReturnDiscountAmount((prev) => {
                                    const updated = [...prev];
                                    updated[index] = num;
                                    return updated;
                                  })
                                  final = base - num;
                                }

                                if (final < 0) final = 0;

                                setReturnedAmount((prev) => {
                                  const updated = [...prev];
                                  updated[index] = final;
                                  return updated;
                                });

                                setTotalPrice((prev) => {
                                  const updated = [...prev];
                                  updated[index] = final;
                                  return updated;
                                });
                              }}
                            />
                          </div>
                        </div>

                        {/* Return Amount */}
                        <div className="flex flex-col sm:flex-row sm:items-center gap-2 mt-3">
                          <input
                            type="text"
                            name="return_amount"
                            className="flex-1 bg-gray-50 border border-[#F1F1FA] rounded-lg py-2 px-3 text-sm focus:outline-none w-full"
                            value={returnedAmount?.[index]?.toFixed(2) ?? item.price?.toFixed(2)}
                            readOnly
                          />
                          <div className="text-base sm:text-lg font-bold text-[#000232] whitespace-nowrap">
                            {(totalPrice?.[index]?.toFixed(2) ?? item.price?.toFixed(2)) + " BDT"}
                          </div>
                        </div>

                        {/* Optional checkbox for salesReturnList */}
                        {type === "salesReturnList" && (
                          <div className="flex items-center gap-1 mt-3">
                            <input
                              type="checkbox"
                              name="status"
                              id={`return_stock_${index}`}
                              checked={isChecked ?? false}
                              onChange={() => setIsChecked(!isChecked)}
                              className="w-4 h-4"
                            />
                            <label
                              htmlFor={`return_stock_${index}`}
                              className="text-gray-600 text-xs"
                            >
                              Return to Stock
                            </label>
                          </div>
                        )}
                      </div>
                    )))}

                    <div className="mt-[25px] flex flex-row gap-2 items-center font-nunito font-[600] text-[18px] text-center">
                      <button
                        onClick={backModalDescription}
                        type="button"
                        className="w-[50%] rounded-[16px] py-[7px] text-[#034AFF] border-[1px] border-solid border-[#034AFF]"
                      >
                        Back
                      </button>
                      {/* <button
                        type="submit"
                        className="w-[50%] bg-[#034AFF] text-[#FCFCFC] py-[8px] rounded-[16px]"
                      >
                        {" "}
                        Done
                      </button>
                      <button onClick={showPymentModal} type="button" className="w-[50%] rounded-[16px] py-[7px] text-[#034AFF] border-[1px] border-solid border-[#034AFF]">
                          Next
                      </button> */}
                      {showPayment ? (
                        <button
                          type="submit"
                          className="w-[50%] bg-[#034AFF] text-[#FCFCFC] py-[8px] rounded-[16px]"
                        >
                          Done
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            showPymentModal();
                          }}
                          className="w-[50%] rounded-[16px] py-[7px] text-[#034AFF] border border-solid border-[#034AFF]"
                        >
                          Next
                        </button>
                      )}
                    </div>
                  </>
                );
              })()}
            </>
          )}
        </div>
      )}
    </form>
  );
};

export default SalesReturnForm;
